@let card = data();

<pai-anchor-card
  [image]="card.image"
  [imageOptions]="card.imageOptions"
  [title]="card.title"
  [text]="card.text"
  [target]="card.linkLabel ? null : card.target"
  [alignment]="card.alignment ?? 'left'"
/>
